import { OnChanges, Output, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SuggestionItem } from 'src/app/common/models/SuggestionItem';

@Component({
    selector: 'app-type-a-head',
    templateUrl: './type-a-head.component.html',
    styleUrls: ['./type-a-head.component.scss'],
    standalone: false
})
export class TypeAHeadComponent implements OnInit, OnChanges {
  @Input() suggestionItemList: any;
  @Input() defaultInputText: any;
  @Input() numberOfSuggestions: number;
  @Output() SelectedItem = new EventEmitter();
  typeahead: UntypedFormControl = new UntypedFormControl();
  suggestions: any = "";
  inputFieldText: any;
  isSuggestDropDownOpen: boolean = false;
  selectsItem = new SuggestionItem();

  constructor() { }

  ngOnInit(): void {
    this.inputFieldText = this.defaultInputText;
  }

  suggest() {
    if (this.typeahead.value != "") {
      this.suggestions = this.suggestionItemList
        .filter(c => c.name.toLowerCase().startsWith(this.typeahead.value.toLowerCase()))
        .slice(0, this.numberOfSuggestions ?? 5);
      this.isSuggestDropDownOpen = true;
    }
    this.selectsItem.id = 0;
    this.selectsItem.name = this.typeahead.value;
    this.SelectedItem.emit(this.selectsItem);
  }

  selectPlace(id) {
    this.selectsItem = this.suggestionItemList.find(x => x.id === id);
    this.SelectedItem.emit(this.selectsItem);
    this.inputFieldText = this.selectsItem.name;
  }
  hideDropDown() {
    this.isSuggestDropDownOpen = !this.isSuggestDropDownOpen;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'defaultInputText': {
            this.inputFieldText = this.defaultInputText;
          }
        }
      }
    }
  }

}
